const routes = {
  basePath: '',
  home: '/',
  orders: 'orders',
  gigOrderCreate: 'creategigorder',
  orderDetail: ':orderId',
  orderJobDetail: ':orderId/jobs/:jobId',
  orderJobDetailOld: ':orderId/jobsold/:jobId',

  clients: 'clients',
  customerDetail: ':customerId',
  customerAccountDetail: ':customerId/accounts/:accountId',
  customerAdminDetail: ':customerId/admin/:adminId',

  contacts: 'contacts',

  invoices: 'invoices',
  invoicesDetail: ':invoiceId',
  invoicesPay: ':invoiceId/pay',
  invoiceHealth: 'invoice-health',
  invoiceGenerator: 'invoice-generator',
  invoiceGeneratorDetail: 'invoice-generator?clientId',
  restrictedAccess: 'restricted-access',
  workers: 'workers',
  workerDetail: ':workerId',

  // Workers V2
  workersV2: 'workers_v2',
  workerV2Detail: ':workerId',
  workerV2SkillDetail: ':workerId/skill/:skillId',

  chat: 'chat',
  inappchat: 'inappchat',

  // Customer Admin
  myTeam: 'my-team',
  myTeamAdminDetail: ':adminId',
  myCompany: 'my-company',
  myCompanyAccountDetail: 'accounts/:accountId',
  myProfile: 'my-profile',

  // Payroll Runs
  payrolls: 'payrolls',
  payrollDetail: ':payrollId',
  // Payroll Runs V2
  payrollsV2: 'payrolls-v2',
  payrollDetailV2: ':payrollId',

  // Reports
  reports: 'reports',

  jobmonitor: 'job-monitor',
  notificationHub: 'notification-hub',

  login: 'login',
  signUp: 'sign-up',
  signOut: 'sign-out',
  forgotPassword: 'forgot-password',
  resetPassword: 'reset-password',
  validationAccount: 'validation-account/:caseId',
  linkExpire: 'link-expire',
  payInvoice: 'pay-invoice/:invoiceId',

  mobileIntro: 'mobile-intro',
  appLogin: 'app-login',
  requestAppAccess: 'request-app-access',
  waitlist: 'waitlist',

  // PDF Generation
  pdf_generation: 'pdf_generation',

  // QR Download
  qrDownload: 'qr/:pdf_auth_key',

  // Payroll Audit
  payrollAudit: 'payroll-audit',

  // Background Audit
  backgroundAudit: 'background-audit',

  // Compliance
  compliance: 'compliance',

  // WorkBright Audit
  workbrightAudit: 'workbright_audit',

  // Zeal Audit
  zealAudit: 'zeal_audit',

  // HelloSign Document Audit
  hellosignAudit: 'hellosign-audit',

  // Timesheet Health Checks
  timesheetHealthChecks: 'timesheet_healthchecks',

  // Worker Exclusion Analyzer
  workerExclusionAnalyzer: 'worker-exclusion-analyzer',

  // Onboarding Bypass
  onboardingBypass: 'onboarding-bypass',
  // I-9 Bypass
  i9Bypass: 'i9-bypass',
  // Dev Password Reset
  passwordReset: 'password-reset-dev',
  // Order Invites
  orderInvites: 'order-invites',

  // Job Debugger
  jobDebugger: 'jobs/:jobId/debug',

  // Job Creator
  jobCreator: 'job-creator',

  // Document Signing (public - worker WebView)
  documentSigning: 'document-signing',

  // Posts Management
  posts: 'posts',
  postCreate: 'create',
  postEdit: ':postId/edit',

  // Document Signing (public, mobile WebView)
  documentSigning: 'document-signing',

  // Document Management
  documents: 'documents',
  documentCreate: 'create',
  documentShow: ':documentId',
  documentEdit: ':documentId/edit',
  documentTestSign: ':documentId/test-sign',

  // AI Assessments
  aiAssessments: 'ai_assessments',
  // Skill Management
  skillManagement: 'skill-management',
  pendingUniforms: 'uniforms',
  pendingCertificates: 'certificates',

  // Worker Accountability (Legacy)
  accountability: 'accountability',
  accountabilityViolations: 'violations',
  accountabilitySuspensions: 'suspensions',
  accountabilityAppeals: 'appeals',
  accountabilityStats: 'stats',

  // No-Show Alerts
  noshowAlerts: 'noshow-alerts',

  // Skills Admin
  skills: 'skills',

  // Regions Management
  regions: 'regions',

  // Client Sessions (hidden fleet view — accessible only via direct URL)
  clientSessions: 'client-sessions',

  // Tasks (New Accountability UI)
  tasks: 'tasks',
  tasksViolations: 'violations',
  tasksViolationDetail: 'violations/:violationId',
  tasksAppeals: 'appeals',
  tasksSuspensions: 'suspensions',
  tasksStats: 'stats',
  tasksViolationApprovers: 'violation-approvers',
};

export default routes;
